import api from './api'

export const sosmedCategoryIndex = async params => {
  return await api
    .get('/api_v2/customer/public/post-category', { params })
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error) {
        // console.log(error)
      }
      return false
    })
}

export const sosmedPostIndex = async params => {
  return await api
    .get('/api_v2/customer/public/posts', { params })
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error) {
        // console.log(error)
      }
      return false
    })
}

export const sosmedPostDetail = async id => {
  return await api
    .get(`/api_v2/customer/public/posts/${id}`)
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error) {
        // console.log(error)
      }
      return false
    })
}

export const sosmedPostLiked = async data => {
  return await api
    .post(`/api_v2/customer/public/posts/liked`, data)
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error) {
        // console.log(error)
      }
      return false
    })
}

export const sosmedCommentStore = async data => {
  return await api
    .post(`/api_v2/customer/public/posts/comment`, data)
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error) {
        // console.log(error)
      }
      return false
    })
}

export const sosmedCommentIndex = async params => {
  return await api
    .get('/api_v2/customer/public/posts/comment', { params })
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error) {
        // console.log(error)
      }
      return false
    })
}
